import { useQuery, useQueryClient } from "@tanstack/react-query";
import exploreCategoriesClient from "../../../api/explore-categories";
import { Klydo } from "../../../Types";

const useExploreCategoriesQuery = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["explore-categories"],
    queryFn: () =>
      exploreCategoriesClient.getAllExploreCategories().then((res) => {
        const klydos = res
          .map((p) => p.klydos)
          .flat()
          .filter(Boolean) as Klydo[];
        for (const klydo of klydos) {
          queryClient.setQueryData(["klydo", klydo.id], klydo);
        }
        return res;
      }),
  });
};
export default useExploreCategoriesQuery;
